/**
 * CrEiCandidateRendererComponent (Level 2 Custom Renderer for cr.Customer)
 *
 * Custom candidate renderer for CR Customer entities within the EI Scoped Lookup.
 * Provides a customer-specific layout with:
 * - Customer icon (fa-address-card) and navigable customer name
 * - Customer number display
 * - Category and assignment type badges
 * - Similarity score with severity coloring
 *
 * Registered via EI_CANDIDATE_RENDERER_REGISTRY for objectTypeAlias 'cr.Customer'.
 * Uses EiCandidateAssignmentService to emit assignment events back to
 * EiScopedLookupComponent (since ngComponentOutlet cannot bind @Output()).
 */
import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';
import {EiLookupCandidateDto} from '../../../../../feature-integration/ei/model/dto/api/ei-lookup-candidate.dto';
import {EiLookupScopeTypeEnum} from '../../../../../feature-integration/ei/enum/ei-lookup-scope-type.enum';
import {
    EiCandidateAssignmentService
} from '../../../../../feature-integration/ei/service/domain/ei-candidate-assignment.service';

@Component({
    selector: 'mvs-cr-ei-candidate-renderer',
    templateUrl: './cr-ei-candidate-renderer.component.html',
    styleUrls: ['./cr-ei-candidate-renderer.component.scss'],
    standalone: false
})
export class CrEiCandidateRendererComponent {

    @Input() candidate: EiLookupCandidateDto;
    @Input() scopeType: EiLookupScopeTypeEnum;

    constructor(
        private assignmentService: EiCandidateAssignmentService,
        private router: Router) {
    }

    get customerName(): string {
        return this.candidate?.displayLabel || '';
    }

    get customerNumber(): string {
        return this.candidate?.displayFields?.['Kundennummer']
            || this.candidate?.displayFields?.['kundennummer'] || '';
    }

    get customerCategory(): string {
        return this.candidate?.displayFields?.['Kategorie']
            || this.candidate?.displayFields?.['kategorie'] || '';
    }

    get assignmentType(): string {
        return this.candidate?.displayFields?.['Zuordnungstyp']
            || this.candidate?.displayFields?.['zuordnungstyp'] || '';
    }

    getSimilaritySeverity(similarity: number): 'success' | 'warn' | 'danger' {
        if (similarity >= 0.8) {
            return 'success';
        }
        if (similarity >= 0.5) {
            return 'warn';
        }
        return 'danger';
    }

    navigateToCustomer(): void {
        if (this.candidate?.entityId) {
            this.router.navigate(['/cr/customers', this.candidate.entityId]);
        }
    }

    assignCandidate(): void {
        this.assignmentService.emitAssignment(this.candidate, this.scopeType);
    }
}
